import { TUser } from '@cian/api-models/monolith-python/cian-api/site/v1/get-user-data-by-request';
import { connect } from 'react-redux';
import { Pagination, IPaginationStoreProps, IPaginationDispatchProps } from '../../components/Pagination';
import { IPageState } from '../../types/page';
import { TThunkDispatch, IApplicationState } from '../../types/redux';
import { fetchFavoriteEntities, IGetFavoriteEntitiesParameters } from '../../actions/favoriteEntities';

interface IPropsForTrackPageview {
  page: IPageState;
  user: TUser;
}

type TStateProps = IPaginationStoreProps & IPropsForTrackPageview;

export function mapStateToProps(state: IApplicationState): TStateProps {
  const { results, user, page } = state;

  return { results, page, user };
}

export function mapDispatchToProps(dispatch: TThunkDispatch): IPaginationDispatchProps {
  return {
    getFavoriteEntities: (parameters: IGetFavoriteEntitiesParameters) => dispatch(fetchFavoriteEntities(parameters)),
  };
}

export const PaginationContainer = connect(mapStateToProps, mapDispatchToProps)(Pagination);
